module.exports = __webpack_public_path__ + "img/Weapon_72.181c3c77.png";